import React, { useState } from "react";
import "../styles/home.css";
 
import { ICONS } from "../../../assets/icons/index";
import { useAspSelector } from "../../../test/jest-redux-hooks";

const Notifications = ({ launchWhatsAppSignup }) => {
  const [isVisible, setIsVisible] = useState(true);

  const { currentBrand, currentAccount } = useAspSelector(
    (state) => state?.app
  );

  const brandMode = currentBrand?.brand_mode;

  const handleCloseNotifications = () => {
    setIsVisible(false);
  };

  // Don't show anything if WhatsApp is connected
  if (currentBrand?.is_whatsapp_connected) return null;

  // Don't show if manually closed
  if (!isVisible) return null;

  // Determine notification message based on brand mode
  const notificationMessage = brandMode === 'test'
    ? "You are in test mode. Connect your WhatsApp Business Account to go live."
    : "Your WhatsApp business account was disconnected";
  return (
    <div
      className="homeHeader ptb-5 text-[0.85rem] flex items-center justify-between flex-1 absolute"
      style={{
        background: "linear-gradient(0deg, rgba(255, 84, 62, 0.16), rgba(255, 84, 62, 0.16))"
      }}
    >
      <div className="flex items-center justify-center flex-grow">
        <p className="text-[#FF543E] font16px-500 pl-3">
          {notificationMessage}
        </p>
        {currentAccount?.role !== "Campaigns Manager" && (
          <button
            className="bg-white py-1 px-2 rounded-xl text-[0.75rem] ml-2 mr-3"
            onClick={() => {
              launchWhatsAppSignup();
            }}
          >
            Connect
          </button>
        )}
      </div>

      <div className="">
        <img
          className="pointer mr-5 w-[2vw] h-[2vw]"
          src={ICONS.popupX}
          alt="popup"
          onClick={handleCloseNotifications}
        />
      </div>
    </div>
  );
};

export default Notifications;
